import React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { FormGroup } from "components/bootstrap";
import PaginatedSelect from "components/common/Select/PaginatedSelect";
import { DELETED_STREAM_TITLE } from "data-lake/Constants";
import fetchDataLakeStreams from "data-lake/preview/utils/fetchDataLakeStreams";
const Container = styled(FormGroup)`
  flex: 1;
`;
const placeholder = "Select the stream you want to preview logs for";
const loadStreams = ({ page, perPage, query }) => fetchDataLakeStreams({ page, perPage, query }).then(({ elements, pagination, total, query: queryRes }) => ({
  list: elements.map(({ stream_title, stream_id }) => ({
    label: stream_title != null ? stream_title : DELETED_STREAM_TITLE,
    value: stream_id
  })),
  pagination: { page: pagination.page, perPage: pagination.per_page, query: queryRes },
  total
}));
const StreamFilter = () => /* @__PURE__ */ React.createElement(Field, { name: "stream" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Container, { "data-testid": "streams-filter", validationState: error ? "error" : void 0, bsClass: "no-bm" }, /* @__PURE__ */ React.createElement(
  PaginatedSelect,
  {
    placeholder,
    displayKey: "key",
    inputId: "streams-filter",
    value,
    onLoadOptions: loadStreams,
    multi: false,
    onChange: (newStream) => {
      onChange({
        target: { value: newStream, name }
      });
    }
  }
)));
export default StreamFilter;
